import {BrowserModule} from '@angular/platform-browser';
import {NgModule, isDevMode} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {MenuComponent} from './menu/menu.component';
import {RegistrierenComponent} from './registrieren/registrieren.component';
import {routing} from './app.routing';
import {PocsagComponent} from './pocsag/pocsag.component';
import {LocalStorageService} from './share/localstorage.service';
import {UserComponent} from './user/user.component';
import {APP_BASE_HREF} from '@angular/common';
import {FahrzeugeComponent} from './fahrzeuge/fahrzeuge.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {UiSwitchModule} from 'ngx-ui-switch';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { DialogComponent } from './dialog/dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { StandortComponent } from './standort/standort.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {PocsagDetailComponent} from './pocsag/pocsag-detail.component';
import {ReleasenotesComponent} from './releasenotes/releasenotes.component';



@NgModule ({ declarations: [
        AppComponent,
        MenuComponent,
        RegistrierenComponent,
        PocsagComponent,
        PocsagDetailComponent,
        UserComponent,
        FahrzeugeComponent,
        ReleasenotesComponent,
        DialogComponent,
        StandortComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        routing,
        LoadingBarHttpClientModule,
        UiSwitchModule,
        BrowserAnimationsModule,
        MatDialogModule,
        GoogleMapsModule


    ], providers: [LocalStorageService,
        { provide: APP_BASE_HREF, useValue: window['_app_base'] || '/' }, provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule {
}



